<template lang="pug">
span.region-stamp.code(v-text="code" v-tooltip="short && name" :data-original-text="name")
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'RegionStamp',

  props: {
    value: {
      type: null,
      required: true
    },

    short: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    ...mapGetters({
      regions: 'master/regions'
    }),

    code () {
      if (typeof this.name !== 'string') return 'N/A'
      if (!this.short) return this.name
      if (this.region && this.region.abbreviated_name) return this.region.abbreviated_name
      return this.name.split(' ').map(i => i[0]).join('')
    },

    region () {
      return this.regions.find(i => i.id === this.value)
    },

    name () {
      return this.$options.filters.region(this.value)
    }
  }
}
</script>

<style lang="scss">
.region-stamp {
  display: inline-block;
  cursor: default;
  white-space: nowrap;
  &.code {
    border: 1px solid #ddd;
    color: black;
    font-size: 13px;
    background-color: white;
    padding: 0 6px;
    border-radius: 3px;
    line-height: 20px;
    font-weight: 500;
  }
  &.plain {
    font-size: 1em;
    border: none;
    margin: 0;
    padding: none;
    background-color: transparent;
    font-weight: $--font-weight-bold;
  }
}
</style>
